import CustomerClient from "../kova/customerClient";
import React, {useContext} from "react";


export const CustomerClientContext = React.createContext<CustomerClient|null>(null);


function useCustomerClient() {
    const retval = useContext(CustomerClientContext);
    if (retval === null) throw new Error('CustomerClient not initialized!');
    return retval;

}

export default useCustomerClient;